import Divider from '../../components/Divider/Divider';
import ListFeatures from './ListFeatures/ListFeatures';

const Features = () => {
  return (
    <section className='features'>
      <Divider />
      <div className='features__container grid-fons'>
        <div className='features__info'>
          <h2 className='features__title title '>
            Essential Features
            <span className='title color'> for Businesses</span>
          </h2>
          <p className='features__text subtitle'>
          Tailored to Cater to the Unique Requirements of Each Size Company
          </p>
        </div>
        <ListFeatures className='features-list' />
      </div>
    </section>
  );
};
export default Features;
